"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyRotationFromQuat = exports.createMat4FromArray = void 0;
const gl_matrix_1 = require("gl-matrix");
const createMat4FromArray = (array) => {
    return gl_matrix_1.mat4.fromValues(array[0], array[1], array[2], array[3], array[4], array[5], array[6], array[7], array[8], array[9], array[10], array[11], array[12], array[13], array[14], array[15]);
};
exports.createMat4FromArray = createMat4FromArray;
const applyRotationFromQuat = (transform, rotation) => {
    const rotationMatrix = gl_matrix_1.mat4.create();
    gl_matrix_1.mat4.fromQuat(rotationMatrix, gl_matrix_1.quat.fromValues(rotation[0], rotation[1], rotation[2], rotation[3]));
    gl_matrix_1.mat4.multiply(transform, rotationMatrix, transform);
};
exports.applyRotationFromQuat = applyRotationFromQuat;
//# sourceMappingURL=mat.js.map